import { helpers } from '@vuelidate/validators';

/** First and last name, in any alphabet; an empty value is left to `required` */
export const fullNameValidator = helpers.withMessage(
  'Please enter your full name (first and last name)',
  (value: string) => {
    if (!value) return true;

    return value.trim().split(/\s+/).length >= 2;
  },
);
